<template>
    <modal @close="modeResetAugmentations">
        <template slot="header_title">
            {{ experience.frozen ? 'Activer' : 'Désactiver' }} cette expérience
        </template>
        <template slot="main">
            <div class="main_frozen_experience">
                <strong v-if="experience.frozen">Vous ne pourrez plus scanner vos images.</strong>
                <strong v-else>Vous pourrez à nouveau scanner vos images.</strong>
                <br>Souhaitez-vous continuer ?
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="modeResetAugmentations">
                        <i class="fas fa-times fa-btn" />
                        <span v-if="!isMobile">Annuler</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_blue" @click="localFrozenExperience">
                        <i class="fa fa-check" />
                        <span v-if="!isMobile">Valider</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'ModalNewAugmentation',
        components: {
            modal: () => import('../../global/modal')
        },
        computed: {
            ...mapGetters('augmentations', ['experience']),
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('augmentations', ['modeResetAugmentations', 'frozenExperience']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localFrozenExperience: function () {
                this.showOverlay();
                this.frozenExperience(!this.experience.frozen).then(() => {
                    this.hideOverlay();
                    this.modeResetAugmentations();
                    this.$toasted.success('L\'éxpérience à bien été ' +
                        (!this.experience.frozen ? 'désactivé' : 'activé'));
                }).catch((err) => {
                    this.hideOverlay();
                    this.modeResetAugmentations();
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .main_frozen_experience {
        padding: 20px;
    }

    .modal-card-foot > .layout {
        margin: 0 !important;
    }
</style>
